import activity from '@shared/assets/icons/sets/default/activity.svg';
import bag from '@shared/assets/icons/sets/default/bag.svg';
import barChart from '@shared/assets/icons/sets/default/bar-chart.svg';
import clock from '@shared/assets/icons/sets/default/clock.svg';
import closeGray from '@shared/assets/icons/sets/default/close-gray.svg';
import cross from '@shared/assets/icons/sets/default/cross.svg';
import ctv from '@shared/assets/icons/sets/default/ctv.svg';
import danger from '@shared/assets/icons/sets/default/danger.svg';
import eye from '@shared/assets/icons/sets/default/eye.svg';
import filterGray from '@shared/assets/icons/sets/default/filters-gray.svg';
import gallery from '@shared/assets/icons/sets/default/gallery.svg';
import game from '@shared/assets/icons/sets/default/game.svg';
import gift from '@shared/assets/icons/sets/default/gift.svg';
import lannerFormat from '@shared/assets/icons/sets/default/lanner-format.svg';
import location from '@shared/assets/icons/sets/default/location.svg';
import paper from '@shared/assets/icons/sets/default/paper.svg';
import phone from '@shared/assets/icons/sets/default/phone.svg';
import pieChart from '@shared/assets/icons/sets/default/pie-chart.svg';
import star from '@shared/assets/icons/sets/default/star.svg';
import thematicCluster from '@shared/assets/icons/sets/default/thematic-cluster.svg';
import thematicPackages from '@shared/assets/icons/sets/default/thematic-packages.svg';
import user from '@shared/assets/icons/sets/default/user.svg';
import videoFormat from '@shared/assets/icons/sets/default/video-format.svg';
import video from '@shared/assets/icons/sets/default/video.svg';
import walletChart from '@shared/assets/icons/sets/default/wallet-chart.svg';
import walletEdit from '@shared/assets/icons/sets/default/wallet-edit.svg';
import walletPlus from '@shared/assets/icons/sets/default/wallet-plus.svg';
import wallet from '@shared/assets/icons/sets/default/wallet.svg';
import { IconVariants } from '@shared/components/Icon/IconMapper.ts';

export const defaultIconMap: Record<IconVariants, string> = {
  activity,
  barChart,
  bag,
  danger,
  eye,
  clock,
  gallery,
  game,
  gift,
  location,
  pieChart,
  star,
  user,
  video,
  wallet,
  walletChart,
  walletPlus,
  walletEdit,
  filterGray,
  closeGray,
  cross,
  ctv,
  phone,
  paper,
  lannerFormat,
  videoFormat,
  thematicPackages,
  thematicCluster,
};
